<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">ONT Find Info</div>
      </div>
    </div>
    <!--页面提示
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the multicast entry." }}
      </p>
    </div>-->
    <div>
      <span style="margin: 1px"></span>
    </div>
    <div>
      <div class="row">
        <div class="col-lg-12" v-show="true">
          <block-cntr
            :btitle="'find ont info'"
            style="height: 100%"
            :closeButton="false"
          >
            <form class="form-horizontal">
              <div
                class="form-group"
                v-for="(value, key) in OntFindInfo"
                :key="key"
              >
                <div class="col-lg-3">
                  <label>{{ value.k }}</label>
                </div>
                <div class="col-lg-8">
                  <label>{{ value.v }}</label>
                </div>
              </div>
            </form>
          </block-cntr>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BlockCntr from "../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontFindInfo",
  components: {
    BlockCntr,
  },
  data() {
    return {
      port: this.$route.query.port,
      index: this.$route.query.index,
      OntFindInfo: "",
    }
  },

  created() {
    this.loadOntFindInfo()
  },

  methods: {
    loadOntFindInfo() {
      get("ontFindInfo?port=" + this.port + "&index=" + this.index)
        .then((res) => (this.OntFindInfo = res.data))
        .catch((err) => {})
    },
  },
}
</script>